import React from "react";
import "./Contact.css";
import { Button } from "@material-ui/core";

const Contact = () => {
  return (
    <div className="contactContainer">
      <a className="mailBtn" href="chiragkrkashyap@gmail.com">
        <Button>Contact: chiragkrkashyap@gmail.com</Button>
      </a>
    </div>
  );
};

export default Contact;
